
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/[[...slug]]",
      function () {
        return require("private-next-pages/business/[[...slug]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/[[...slug]]"])
      });
    }
  